import { benchmarksEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import type { GenerateBenchmarkRequestType, GenerateBenchmarkResponseType } from "@/types";

type ApiGenerateEnvelopeType = {
    data: {
        cached?: boolean,
        estimated_time_seconds: number,
        job_id: string,
        status_url: string,
    },
};

export const generateBenchmarkHandler = async ({
    industry,
    jobDescription,
    jobTitle,
    seniority,
}: GenerateBenchmarkRequestType): Promise<GenerateBenchmarkResponseType> => {
    const payload = {
        industry: industry,
        job_description: jobDescription, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case payload
        job_title: jobTitle, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case payload
        seniority: seniority,
    };

    const response = await axiosClient.post<ApiGenerateEnvelopeType>(
        benchmarksEndpoints.process,
        payload,
    );

    const { data } = response.data;

    return {
        cached: data.cached ?? false,
        estimatedTimeSeconds: data.estimated_time_seconds,
        jobId: data.job_id,
        statusUrl: data.status_url,
    };
};
